import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle, Infinity as InfinityIcon } from "lucide-react";

/**
 * ExtraCreditBalance
 * Displays the extra credit balance with an "Add Credits" button
 * and a "Does not expire" indicator.
 */

interface ExtraCreditBalanceProps {
  balanceCents: number;
  onAddCredits?: () => void;
}

function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export const ExtraCreditBalance: React.FC<ExtraCreditBalanceProps> = ({
  balanceCents,
  onAddCredits,
}) => {
  const navigate = useNavigate();

  const handleAddCredits = () => {
    if (onAddCredits) {
      onAddCredits();
    } else {
      navigate("/billing");
    }
  };

  return (
    <div className="flex items-center justify-between rounded-lg border border-border bg-card p-4">
      <div className="space-y-1">
        <p className="text-sm text-muted-foreground">Extra Credits</p>
        <p className="text-2xl font-bold text-foreground">
          {formatCents(balanceCents)}
        </p>
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <InfinityIcon className="h-3 w-3" />
          <span>Does not expire</span>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleAddCredits}
        className="gap-1.5"
      >
        <PlusCircle className="h-4 w-4" />
        Add Credits
      </Button>
    </div>
  );
};
